/**
 * 404 Not Found page
 */
import React from "react";
import { Link } from "react-router";
import { Home, ArrowLeft } from "lucide-react";

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="text-center">
        <div className="mx-auto max-w-md">
          <div className="text-6xl font-bold text-gray-900 mb-4">404</div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Page not found
          </h1>
          <p className="text-gray-600 mb-8">
            Sorry, we couldn't find the page you're looking for.
          </p>

          <div className="space-y-3 sm:space-y-0 sm:space-x-4 sm:flex sm:justify-center">
            <button
              onClick={() => window.history.back()}
              className="w-full sm:w-auto btn-secondary inline-flex items-center justify-center"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Go back
            </button>

            <Link
              to="/flows"
              className="w-full sm:w-auto btn-primary inline-flex items-center justify-center"
            >
              <Home className="w-4 h-4 mr-2" />
              Go to Flows
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
